import { post } from '../lib/http'

// Auth API request/response types
export interface ThirdLoginRequest {
  provider: 'google' | 'github' | 'apple'
  idToken: string
}

export interface ThirdLoginResponse {
  token: string
  user: {
    id: string
    email: string
    displayName: string
    avatarUrl?: string
    provider: string
  }
  isNewUser: boolean
}

// Third-party login API
export const thirdLogin = (data: ThirdLoginRequest): Promise<ThirdLoginResponse> => {
  return post<ThirdLoginResponse>('/auth/third-login', { data })
}
